import React, { useEffect, useState } from "react";
import {
  Link,
  useLocation,
  useNavigate,
  useNavigation,
  useParams,
} from "react-router-dom";
import styled from "styled-components";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { getAuth } from "firebase/auth";
import Drag from "../Components/draganddrop";
import cross from "../Assets/cross.svg";
import DummyImage from "../Assets/product_img.svg";
import upload from "../Assets/drag.svg";
import RestaurantMenuIcon from "@mui/icons-material/RestaurantMenu";
import {
  Box,
  Chip as MuiChip,
  Divider as MuiDivider,
  Grid,
  Paper as MuiPaper,
  Typography,
  TableRow,
  TableCell,
  Tooltip,
  IconButton,
} from "@material-ui/core";

import { Edit as EditIcon } from "@material-ui/icons";

import { spacing } from "@material-ui/system";
import { useHistory } from "react-router-dom";
import CheckboxLabels from "../Components/Checkbox";
import InputField from "../Components/inputfield";
import ButtonComponent from "../Components/buttton";
import UploadImage from "../Components/uploadimage";
import ButtonIconComponent from "../Components/ButtonIcons";
import {
  GetAllData,
  GetAllDataNestedCollections,
  GetSingleData,
  UpdateSingleDoc,
  getDocumentIds,
  getDocumentIdsFromNestedCollection,
} from "../NetworkCalls/Admin/ServerReq";
import { toast } from "react-toastify";

const Divider = styled(MuiDivider)(spacing);
const Paper = styled(MuiPaper)(spacing);

function handleClick(event) {
  event.preventDefault();
  console.info("You clicked a breadcrumb.");
}

function BasicBreadcrumbs() {
  const params = useParams();
  return (
    <div role="presentation">
      <Breadcrumbs aria-label="breadcrumb">
        <Link
          to={"/dashboard/resturants"}
          underline="hover"
          color="#000"
          style={{ color: "#410660" }}
        >
          {" "}
          {params.category}
        </Link>
        <Typography
          color="text.primary"
          style={{ fontWeight: "500", color: "#410660" }}
        >
          Edit {params.category}
        </Typography>
      </Breadcrumbs>
    </div>
  );
}

const EditResturant = () => {
  const history = useNavigate();
  const params = useParams();

  const [Error, setError] = useState("");
  const [data, setData] = useState({});
  const [menu, setMenus] = useState({});
  const [menusDocumentIds, setMenusDocumentIds] = useState([]);
  const [selectedMenu, setSelectedMenu] = useState(null);

  const [amenities, setAmenities] = useState({});

  const handleOnchange = (e) => {
    const { name, value } = e.target;
    setData((preValue) => {
      return {
        ...preValue,
        [name]: value,
        category: selectedMenu ? selectedMenu.category : data.category,
      };
    });
  };

  // =======
  const [loader, setLoader] = useState(false);
  const [saveImageLoading, setSaveImageLoading] = useState(false);
  const [saveRestaurantDetailsLoading, setSaveRestaurantDetailsLoading] =
    useState(false);
  const [saveAmenitiesLoading, setSaveAmenitiesLoading] = useState(false);
  const [mainLoader, setMainLoader] = useState(true);
  const [imgweb, setImgweb] = useState("");
  const [tempimg, setTempimg] = useState("");

  console.log("imgweb");
  console.log(imgweb);

  console.log("tempimg");
  console.log(tempimg);

  const { state } = useLocation();
  const [open, setOpen] = useState(false);

  const [checkedAmenities, setCheckedAmenities] = useState([]);
  const [menusDataSubCollection, setMenusDataSubCollection] = useState([]);

  const handleClose = () => {
    setOpen(!open);
    history.push({ pathname: "/dashboard/nfts" });
    // setUpdate(!dataupdate)
  };

  async function handleClick(event) {
    event.preventDefault();
    setOpen(true);
  }

  useEffect(() => {
    const getData = async () => {
      try {
        setLoader(true);
        const response = await GetSingleData(
          params.category,
          params.categoryid
        );
        setCheckedAmenities(response?.ameneities);

        setData(response);

        setLoader(false);
        setImgweb(response?.imageLink);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getData();
  }, []);

  useEffect(() => {
    const getMenus = async () => {
      try {
        setLoader(true);
        const response = await GetAllData("TopMenus");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });

        setMenus(arr);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getMenus();
  }, []);

  useEffect(() => {
    const getAmenities = async () => {
      try {
        setLoader(true);
        const response = await GetAllData("Amenities");

        let arr = [];
        response.forEach((doc) => {
          arr.push(doc.data());
        });

        arr.sort((a, b) => a.name.localeCompare(b.name));

        setAmenities(arr);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getAmenities();
  }, []);

  useEffect(() => {
    const getAllMenusID = async () => {
      try {
        const response = await getDocumentIdsFromNestedCollection(
          params?.category,
          params?.categoryid,
          "Menu"
        );
        setMenusDocumentIds(response);
      } catch (err) {
      } finally {
      }
    };

    getAllMenusID();
  }, []);

  useEffect(() => {
    const getAllMenus = async () => {
      try {
        setLoader(true);
        const response = await GetAllDataNestedCollections(
          params.category,
          params.categoryid,
          "Menu"
        );

        setMenusDataSubCollection(response);

        setLoader(false);
      } catch (err) {
        console.log(err);
        setLoader(false);
      } finally {
        setLoader(false);
      }
    };

    getAllMenus();
  }, []);

  const handleSaveResturantDetails = async (event) => {
    // setLoader(true);
    setSaveRestaurantDetailsLoading(true);
    event.preventDefault();
    setError("");

    try {
      await UpdateSingleDoc(params.category, params.categoryid, {
        ...data,
        category: selectedMenu,
      });
      setSaveRestaurantDetailsLoading(false);
    } catch (e) {
      setError(e);
      setSaveRestaurantDetailsLoading(true);
    } finally {
      setSaveRestaurantDetailsLoading(false);
    }
  };

  const handleSaveResturantImage = async (event) => {
    event.preventDefault();

    if (tempimg === "") {
      toast.error("Please add an image");
      return;
    }

    setSaveImageLoading(true);
    setError("");

    UploadImage({ img: tempimg })
      .then(async (res) => {
        setImgweb(res);
        await UpdateSingleDoc(params.category, params.categoryid, {
          imageLink: res,
        });
        setImgweb("");
        setSaveImageLoading(false);
      })
      .catch((e) => {
        setError(e);
        setSaveImageLoading(true);
      })
      .finally(() => {
        setSaveImageLoading(false);
      });
  };

  // console.log(blogdata?.blogimg)
  const { setDragOver, onDragOver, onDragLeave, setFileDropError } = Drag();

  const onDrop = (e) => {
    e.preventDefault();

    setDragOver(false);

    const selectedFile = e?.dataTransfer?.files[0];

    if (selectedFile.type.split("/")[0] !== "image") {
      return setFileDropError("Please provide an image file to upload!");
    }

    setTempimg(selectedFile);
  };

  const addCheckboxes = (e) => {
    const { name, checked } = e.target;

    if (checked) {
      setCheckedAmenities((prevChecked) => [...prevChecked, name]);
    } else {
      setCheckedAmenities((prevChecked) =>
        prevChecked.filter((id) => id !== name)
      );
    }
  };

  const handleSaveAmenities = async (e) => {
    e.preventDefault();

    try {
      setSaveAmenitiesLoading(true);

      await UpdateSingleDoc(params.category, params.categoryid, {
        ameneities: checkedAmenities,
      });

      setSaveAmenitiesLoading(false);
    } catch (e) {
      setError(e);
      setSaveAmenitiesLoading(true);
    } finally {
      setSaveAmenitiesLoading(false);
    }
  };

  return (
    <React.Fragment>
      <Grid
        style={{ marginBottom: "10px" }}
        justify="space-between"
        container
        spacing={24}
      >
        <Grid item>
          <Typography variant="h4" gutterBottom display="inline">
            Edit {params.category}
          </Typography>
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Grid container spacing={6}>
        <Grid item xs={12}>
          <BasicBreadcrumbs />
        </Grid>
      </Grid>

      <Divider
        my={6}
        style={{
          marginTop: "20px",
          marginBottom: "20px",
          backgroundColor: "#fafafa",
        }}
      />

      <Paper
        style={{
          boxShadow: "none !important",
          border: "1px solid rgba(76, 78, 100, 0.25)",
          borderRadius: "10px",
          padding: "10px",
        }}
      >
        <Grid item xs={12} xl={6} lg={12} md={6}>
          <h1
            style={{
              fontWeight: "400",
              fontSize: "25px",
              color: "#410660",

              marginBottom: "40px",
            }}
          >
            {params.category} Information
          </h1>

          {/* ========= */}

          <Grid
            style={{ marginBottom: "10px", marginTop: "35px" }}
            justify="space-around"
            container
            spacing={2}
          >
            <Grid item xs={12} xl={12} lg={12} md={12}>
              <p style={{ fontSize: "20px", marginBottom: "20px" }}>
                Upload Image*
              </p>
              {/* ======= */}
              {/* {(!tempimg && !data?.imageLink) || tempimg === "" ? ( */}
              {!imgweb && tempimg === "" ? (
                <div className="addImage"
                  for="upload-photo"
                  onDragOver={onDragOver}
                  onDragLeave={onDragLeave}
                  onDrop={onDrop}>
                  <div className="imagebody"  >

                    <img
                      src={upload}
                      style={{ marginBottom: "20px" }}
                      alt="upload"
                    />
                    <p>
                      Drag and drop an image, or{" "}
                      <label
                        for="upload-photo"
                        className="upload-label"
                      >
                        Browse{" "}
                      </label>
                      <input
                        type="file"
                        name="WebImage"
                        onChange={(e) => {
                          setTempimg(e.target.files[0]);
                          // setImgweb(e.target.files[0]);
                        }}
                        id="upload-photo"
                        style={{ display: "none" }}
                        // required={true}
                      />
                      <br /> 1600x1200 or higher recommended. Max 10MB.
                    </p>
                  </div>
                </div>
              ) : (
                <div className="addImage">
                  <div
                    style={{
                      width: "100%",
                      height: "100%",
                      position: "relative",
                    }}
                  >
                    {imgweb ? (
                      data?.imageLink !== "" && (
                        <img
                          src={data?.imageLink}
                          style={{ width: "100%", height: "100%" }}
                        />
                      )
                    ) : (
                      <img
                        src={URL.createObjectURL(tempimg)}
                        style={{ width: "100%", height: "100%" }}
                      />
                    )}

                    <img
                      src={cross}
                      style={{
                        width: "35px",
                        top: "-25px",
                        position: "absolute",
                        right: "-25px",
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        console.log("hello");
                        setImgweb("");
                        setTempimg("");
                      }}
                      // onClick={() => {
                      //   setTempimg("");
                      // }}
                    />
                  </div>
                </div>
              )}
              {/* ======== */}
            </Grid>
          </Grid>

          {/* ======== */}

          <div
            style={{
              width: "30%",
            }}
          >
            <ButtonIconComponent
              loader={saveImageLoading}
              name="Save Image"
              onClick={handleSaveResturantImage}
              imageBool={false}
            />
          </div>
        </Grid>

        <div className="dashboard_container">
          <form>
            <Grid
              style={{ marginBottom: "10px", marginTop: "35px" }}
              container
              spacing={2}
            >
              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="businessName"
                  label="Restaurant Name"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.businessName}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="address"
                  label="Address"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.address}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="city"
                  label="City"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.city}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="email"
                  label="Email"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.email}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="phone"
                  label="Phone"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.phone}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="state"
                  label="State"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.state}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="url"
                  label="URL"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.url}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              <Grid item xs={12} xl={6} lg={6} md={6}>
                <TextField
                  id="outlined-basic"
                  type="text"
                  name="zip"
                  label="Zipcode"
                  variant="outlined"
                  InputLabelProps={{ shrink: true }}
                  value={data?.zip}
                  onChange={handleOnchange}
                  fullWidth={true}
                />
              </Grid>

              {/* ======== */}
            </Grid>

            <Grid
              item
              xs={12}
              xl={6}
              lg={6}
              md={6}
              style={{ margin: "0px auto" }}
            >
              <Grid
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  gap: "10px",
                  marginBottom: "20px",
                }}
              >
                {menu &&
                  menu.length > 0 &&
                  menu.map((item, index) => (
                    <div
                      className={` ${
                        selectedMenu === item?.id || data?.category === item?.id
                          ? "hover-effect-menus"
                          : ""
                      }`}
                      key={index}
                      style={{
                        backgroundColor: "#410660",
                        maxWidth: "100px",
                        minWidth: "100px",
                        textAlign: "center",
                        borderRadius: "5px",
                        padding: "7px",
                        transition: "all 0.3s",
                        cursor: "pointer",
                      }}
                      onClick={() => setSelectedMenu(item?.id)}
                    >
                      {/* <p style={{
                        border:"2px solid white",
                      }}>{selectedMenu}</p> */}
                      {/* <p style={{
                        border:"2px solid white"
                      }}>{item.id}</p> */}
                      <img
                        alt="logo"
                        src="/assets/african.png"
                        style={{
                          width: "25px",
                        }}
                      />
                      <p
                        style={{
                          color: "#fff",
                          fontSize: "10px",
                          marginTop: "-2px",
                        }}
                      >
                        {item.name}
                      </p>
                    </div>
                  ))}
              </Grid>

              <ButtonIconComponent
                name="Save "
                loader={saveRestaurantDetailsLoading}
                onClick={handleSaveResturantDetails}
                imageBool={false}
              />
            </Grid>

            {/* ========== */}

            <Grid
              style={{
                marginTop: "50px",
              }}
            >
              <Box>
                <h1
                  style={{
                    fontWeight: "400",
                    fontSize: "25px",
                    color: "#410660",

                    marginBottom: "40px",
                  }}
                >
                  Food Information
                </h1>
              </Box>
            </Grid>

            {/* List of menus */}

            <Grid
              style={{
                width: "100%",
                marginBottom: "50px",
              }}
            >
              {menusDataSubCollection &&
                menusDataSubCollection.length > 0 &&
                menusDataSubCollection.map((item, index) => (
                  <Box
                    key={index}
                    style={{
                      width: "100%",
                      border: "1px solid rgba(76, 78, 100, 0.25)",
                      borderRadius: "10px",
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                      alignItems: "center",
                      padding: "7px",
                      marginBottom: "10px",
                    }}
                  >
                    <Box
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "center",
                        alignItems: "center",
                        gap: "1rem",
                      }}
                    >
                      <RestaurantMenuIcon style={{ color: "#757575" }} />

                      <Box
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "flex-start",
                          flexDirection: "column",
                        }}
                      >
                        <Typography
                          style={{
                            fontWeight: "600",
                            fontSize: "16px",
                            color: "#212121",
                          }}
                        >
                          {item?.name}
                        </Typography>{" "}
                        <Typography
                          style={{
                            fontWeight: "400",
                            fontSize: "12px",
                            color: "#212121",
                          }}
                        >
                          {item?.description}
                        </Typography>{" "}
                      </Box>
                    </Box>

                    <Box align="left">
                      <Link
                        to={{
                          pathname: `/dashboard/${params.category}/${data?.id}/edit_menu/${menusDocumentIds[index]}`,
                        }}
                      >
                        <Tooltip title="Edit Menu">
                          <IconButton>
                            <EditIcon />
                          </IconButton>
                        </Tooltip>
                      </Link>
                    </Box>
                  </Box>
                ))}
            </Grid>

            {params?.category === "Restaurants" && (
              <>
                <Grid
                  container
                  style={{
                    marginBottom: "40px",
                  }}
                >
                  {amenities &&
                    amenities.length > 0 &&
                    amenities.map((item, index) => (
                      <Grid key={index} item xs={12} md={6} lg={3} xl={4}>
                        <CheckboxLabels
                          name={item.id}
                          Label={item.name}
                          check={
                            checkedAmenities &&
                            checkedAmenities.includes(item.id)
                          }
                          onClick={addCheckboxes}
                        />
                      </Grid>
                    ))}
                </Grid>

                <div
                  style={{
                    width: "50%",
                    margin: "0px auto",
                  }}
                >
                  <ButtonIconComponent
                    loader={saveAmenitiesLoading}
                    name="Save Amenities"
                    // onClick={() => console.log("Template")}
                    onClick={handleSaveAmenities}
                    imageBool={false}
                  />
                </div>
              </>
            )}

            <Box mt={2}>
              <Typography style={{ color: "#E12F2F" }}>{Error}</Typography>
            </Box>
            {/* <button>hdsdsu</button> */}
          </form>
        </div>
      </Paper>
    </React.Fragment>
  );
};

export default EditResturant;
